export const validateName = (name) => {
  if (name.length >= 3) {
    return true;
  } else return false;
};
